exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whole_div[data-v-48031712]{background-color:#fff;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999}", ""]);

// exports
